import React, { useState } from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import { EnvelopeFill, TelephoneFill, GeoAltFill } from 'react-bootstrap-icons';

export default function Contact() {

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Send form data using Fetch
    const form = e.target;
    const formData = new FormData(form);

    fetch('https://formspree.io/f/mzzrwgpg', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          setSubmitted(true);
          form.reset();
        }
      })
      .catch((error) => {
        console.error('Submission error:', error);
      });
  };

  return (
    <div className=" py-5">
      <Container>
        <h2 className="text-center mb-5">Contact Us</h2>


        <Row>
          <Col md={6}>
            {submitted && (
              <Alert variant="success" onClose={() => setSubmitted(false)} dismissible>
                Thank you! Your Enquiry has been registered. We are looking forward to connecting with you.
              </Alert>
            )}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="name" className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Name"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email address</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder="Email address"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="phone" className="form-label">Phone Number</label>
                <input
                  type="tel"
                  className="form-control"
                  id="phone"
                  name="phone"
                  placeholder="Phone Number"
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  className="form-control"
                  id="message"
                  name="message"
                  rows="5"
                  placeholder="Your message"
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">Submit</button>
            </form>
          </Col>

          <Col md={6}>
            <h4 className="text-center mb-3">Get in Touch</h4>
            <p className="text-center">We'd love to hear from you! Please fill out the form or reach us through the contact details below.</p>
            <p className="text-center contact-email">For inquiries, please email us at <a href="mailto:sales@sanjayenterprises.co.in">sales@sanjayenterprises.co.in</a></p>
            <p className="text-center contact-email">Or call us at <a href="tel:+919607009796">+91 96070 09796</a></p>
            <p className="text-center contact-email"><a href="tel:+917888159898">+91 78881 59898</a></p>
            <p className="text-center">We look forward to connecting with you!</p>

            <p className="text-center">Follow us on LinkedIn for updates and news!</p>
            <div className="text-center">
              <a href="https://www.facebook.com/sanjayenterprisespune" target="_blank" rel="noopener noreferrer" className="me-3">
              <i className="bi bi-facebook"></i>
            </a>
            {/* <a href="https://www.instagram.com/sanjayenterprisespune/" target="_blank" rel="noopener noreferrer" className="me-3">
              <img src="/images/instagram-icon.png" alt="Instagram" width="30" />
            </a>
            <a href="https://www.linkedin.com/company/sanjay-enterprises-pune/" target="_blank" rel="noopener noreferrer">
              <img src="/images/linkedin-icon.png" alt="LinkedIn" width="30" /> */}
              <a href="https://www.linkedin.com/company/107351648/admin/dashboard/" target="_blank" rel="noopener noreferrer" className="me-3">
                <i className="bi bi-linkedin"></i>
              </a>
            </div>
          </Col>
        </Row>

        <hr />

        <Row className="my-5">

          <Col md={6} className="my-5">

            <h5><GeoAltFill className="me-2" /> Address</h5>
            <p>Gat No. 169, Shop No. 007, Sonul Industrial Complex,<br />Nr. Saraswati school, Rupeenagar, Talawade<br />Pune, Maharashtra - 411062 </p>

            <hr />

            <h5><EnvelopeFill className="me-2" /> Email</h5>
            <p className="contact-email"><a href="mailto:sales@sanjayenterprises.co.in">sales@sanjayenterprises.co.in</a></p>

            <hr />

            <h5><TelephoneFill className="me-2" /> Phone</h5>
            <p>+91 96070 09796</p>
            <p>+91 78881 59898</p>

          </Col>
          <Col>
            <h4 className="text-center mb-3">Our Location</h4>
            <div className="map-responsive">
              <iframe
                title="map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d60476.545235005346!2d73.70974644863281!3d18.673682900000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2b7511c1cbf91%3A0x728116cc84a7f8aa!2sSanjay%20Enterprises!5e0!3m2!1sen!2sin!4v1747666794578!5m2!1sen!2sin"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </Col>
        </Row>



      </Container>
    </div>
  );
}
